import React, { useState } from "react";
import Icon from "../Icon";
import { Button } from "../primitives";
import { NAME_MAX_LEN, URL_MAX_LEN, normalizeAndValidateUrl } from "../../../../utils/linkUrl";

/** Platform Links section: list + inline add form (AddLinkSheet rules). Links are always public. */
export default function LinkEditor({ links, disabled, max = Infinity, onAdd, onRemove, testId = "linkEditor" }) {
  const [adding, setAdding] = useState(false);
  const [url, setUrl] = useState("");
  const [name, setName] = useState("");
  const { normalized, valid } = normalizeAndValidateUrl(url);
  const canSave = valid && name.trim().length > 0;
  const showError = url.trim().length > 0 && !valid;

  const save = () => {
    if (!canSave) return;
    onAdd({ url: normalized, name: name.trim(), is_members_only: false });
    setUrl(""); setName(""); setAdding(false);
  };

  return (
    <div className="field">
      <span>Links</span>
      {links.map((l, i) => (
        <div className="cc-row" key={`${l.url}-${i}`}>
          <span className="icirc" style={{ width: 36, height: 36 }}><Icon name="link" size={16} /></span>
          <div className="grow" style={{ minWidth: 0 }}>
            <b className="ellip" style={{ display: "block" }}>{l.name || l.url}</b>
            {l.name && <div className="meta ellip">{l.url}</div>}
          </div>
          <button type="button" className="ibtn" aria-label={`Remove ${l.name || l.url}`} disabled={disabled} onClick={() => onRemove(i)} data-testid={`${testId}.${i}.remove`}><Icon name="x" size={16} /></button>
        </div>
      ))}
      {adding ? (
        <div className="col" style={{ background: "var(--wash)", borderRadius: 14, padding: 14 }}>
          <label className="field">
            <span>URL *</span>
            <input className="input" type="url" inputMode="url" autoCapitalize="none" spellCheck={false} maxLength={URL_MAX_LEN}
              value={url} onChange={(e) => setUrl(e.target.value)} placeholder="e.g. https://instagram.com/yourclub" data-testid={`${testId}.url`} />
            {showError && <span className="err-text">Enter a valid link, e.g. https://instagram.com/yourclub</span>}
          </label>
          <label className="field">
            <span>Name for URL *</span>
            <input className="input" maxLength={NAME_MAX_LEN} value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Club Instagram" data-testid={`${testId}.name`}
              onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); save(); } }} />
          </label>
          <div className="row" style={{ justifyContent: "flex-end" }}>
            <Button variant="ghost" size="sm" onClick={() => { setAdding(false); setUrl(""); setName(""); }} data-testid={`${testId}.cancel`}>Cancel</Button>
            <Button size="sm" disabled={!canSave} onClick={save} data-testid={`${testId}.save`}>Add link</Button>
          </div>
        </div>
      ) : (
        <>
          <Button variant="ghost" size="sm" icon="plus" style={{ alignSelf: "flex-start" }} disabled={disabled || links.length >= max} onClick={() => setAdding(true)} data-testid={`${testId}.add`}>Add link</Button>
          {links.length >= max && <span className="meta">Up to {max} links.</span>}
        </>
      )}
    </div>
  );
}
